import React from "react";
import styles from "./About.module.css";
import princess from "../../assets/diamonds/diamond_princess.png";
import emerald from "../../assets/diamonds/diamond_emerald.png";
import round from "../../assets/diamonds/diamond_round.png";
import TestimonialSection from "../../components/TestimonialSection/TestimonialSection";
import ContactPromptSection from "../../components/ContactPromptSection/ContactPromptSection";
import CertificationsSection from "../../components/CertificationsSection/CertificationsSection";
import logoIGI from "../../assets/images/logo_IGI.png";
import logoJBT from "../../assets/images/logo_JBT.png";
import logoVDB from "../../assets/images/logo_VDB.png";
import { useState } from "react";
import { testimonials } from "../../constants/constants";
const About = () => {
  return (
    <div className={styles.mainContainer}>
      <section className={"container"}>
        <div className={styles.sectionCircle1} />
        <div className={styles.sectionCircle2} />
        <div className={styles.contentWrapper}>
          <div className={styles.leftBlock}>
            <h1 className={styles.heading}>
              Where <span className={styles.headingHighlight}>Innovation</span>
              <br />
              Meets <span className={styles.headingHighlight2}>Brilliance</span>
            </h1>
            <div className={styles.asscherWrapper}>
              <img
                src={princess}
                alt="Princess Diamond"
                className={styles.diamondAsscher}
              />
            </div>
          </div>
          <div className={styles.centerBlock}>
            <div className={styles.emeraldWrapper}>
              <img
                src={emerald}
                alt="Emerald Diamond"
                className={styles.diamondEmerald}
              />
            </div>
          </div>
          <div className={styles.rightBlock}>
            <div className={styles.roundWrapper}>
              <img
                src={round}
                alt="Round Diamond"
                className={styles.diamondRound}
              />
            </div>
            <p className={styles.description}>
              At the heart of every diamond we create is a story of passion,
              precision, and purpose—crafted to celebrate your most meaningful
              moments.
            </p>
          </div>
        </div>
      </section>
      {/* ABOUT US TEXT SECTION START */}
      <section
        className={styles.aboutTextSection}
        aria-label="About Us Description"
      >
        <h2 className={styles.aboutTextHeading}>About Us</h2>
        <p className={styles.aboutTextParagraph}>
          At Green Rock Creations Corp., we’re redefining the world of fine
          jewelry—one lab-grown diamond at a time. As expert diamond growers and
          direct wholesalers, we specialize in crafting ethically produced,
          scientifically perfect stones that rival natural diamonds in beauty,
          but not in cost.
        </p>
        <p className={styles.aboutTextParagraph}>
          Founded on the principles of transparency, sustainability, and
          precision, Green Rock Creations, brings cutting-edge technology to an
          age-old industry. Our diamonds are grown in advanced labs under
          controlled conditions that replicate the Earth’s natural
          process—delivering flawless gems without the environmental or ethical
          concerns of traditional mining.
        </p>
        <p className={styles.aboutTextParagraph}>
          What truly sets us apart? Our pricing. By eliminating middlemen and
          selling directly to jewelers, designers, and manufacturers, we offer
          exceptionally aggressive wholesale rates—without ever compromising on
          quality.
        </p>
        <p className={styles.aboutTextParagraph}>
          Whether you're sourcing for a new collection or seeking a trusted
          partner in the lab-grown revolution, Green Rock Creations delivers
          unmatched brilliance, value, and trust.
        </p>
      </section>
      {/* ABOUT US TEXT SECTION END */}
      {/* QUOTE SECTION START */}
      <section className={styles.quoteSection} aria-label="Diamond Story Quote">
        <blockquote className={styles.quoteBlock}>
          <span className={styles.quoteLine1}>
            <span className={styles.quoteAccent}>"A diamond is Forever</span>
            --but <br />
            its story begins with you."
          </span>
        </blockquote>
      </section>

      {/* Contact Prompt Section */}
      <ContactPromptSection
        text={`Advanced Design Drives Beauty & Brilliant Sparkle`}
      />
      {/* Certifications Section */}
      <CertificationsSection
        logoIGI={logoIGI}
        logoJBT={logoJBT}
        logoVDB={logoVDB}
      />
    </div>
  );
};

export default About;
